var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import ConsentCookie from "./ConsentCookie";
import CookieContainer from "./CookieContainer";
import MotomoAnalytics from "./MotomoAnalytics";
/**
 * User's cookie policy.
 * */
var CookiePolicy = /** @class */ (function () {
    function CookiePolicy(config) {
        this._config = config;
        this.disableGoogleAnalyticsCookies();
    }
    CookiePolicy.prototype.enforce = function () {
        if (!this.isAll()) {
            this.disableOptionalCookies();
        }
    };
    CookiePolicy.prototype.setPageView = function (path) {
        if (this._config.matomoPath && this.isAll()) {
            MotomoAnalytics.pageView(path, true);
        }
    };
    /**
     * Has user consented to the use of cookies?
     * */
    CookiePolicy.prototype.isConsented = function () {
        return this.isAll() || this.isNecessaryOnly();
    };
    /**
     * Has user consented to the use of _all_ cookies?
     * */
    CookiePolicy.prototype.isAll = function () {
        return ConsentCookie.isAll();
    };
    /**
     * Has user consented only to the use of necessary cookies?
     * */
    CookiePolicy.prototype.isNecessaryOnly = function () {
        return ConsentCookie.isNecessaryOnly();
    };
    /**
     * Give consent to the use of all cookies.
     * */
    CookiePolicy.prototype.consentToAll = function () {
        var _a = this._config.cookieConsent, expiryDays = _a.expiryDays, domain = _a.domain, path = _a.path;
        ConsentCookie.setAll(expiryDays, domain, path);
    };
    /**
     * Give consent to the use of necessary cookies only.
     * */
    CookiePolicy.prototype.consentToNecessaryOnly = function () {
        var _a = this._config.cookieConsent, expiryDays = _a.expiryDays, domain = _a.domain, path = _a.path;
        ConsentCookie.setNecessaryOnly(expiryDays, domain, path);
        this.disableOptionalCookies();
    };
    /**
     * Disable old Google Analytics cookies
     *
     * */
    CookiePolicy.prototype.disableGoogleAnalyticsCookies = function () {
        var e_1, _a, e_2, _b;
        var _c = this._config.cookieConsent, expiryDays = _c.expiryDays, domain = _c.domain, path = _c.path;
        var gaCookies = CookieContainer.findCookies(/^(_gid|_ga.*)/);
        if (gaCookies.length > 0) {
            try {
                for (var gaCookies_1 = __values(gaCookies), gaCookies_1_1 = gaCookies_1.next(); !gaCookies_1_1.done; gaCookies_1_1 = gaCookies_1.next()) {
                    var cookie = gaCookies_1_1.value;
                    CookieContainer.delete(cookie, domain, path);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (gaCookies_1_1 && !gaCookies_1_1.done && (_a = gaCookies_1.return)) _a.call(gaCookies_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        var gaConsentCookies = CookieContainer.findCookies(/^(_consent.*)/);
        try {
            for (var gaConsentCookies_1 = __values(gaConsentCookies), gaConsentCookies_1_1 = gaConsentCookies_1.next(); !gaConsentCookies_1_1.done; gaConsentCookies_1_1 = gaConsentCookies_1.next()) {
                var cookie = gaConsentCookies_1_1.value;
                CookieContainer.delete(cookie, domain, path);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (gaConsentCookies_1_1 && !gaConsentCookies_1_1.done && (_b = gaConsentCookies_1.return)) _b.call(gaConsentCookies_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
    CookiePolicy.prototype.disableOptionalCookies = function () {
        var e_3, _a;
        var _b = this._config.cookieConsent, domain = _b.domain, path = _b.path;
        var mCookies = CookieContainer.findCookies(/^(_pk.*)/);
        try {
            for (var mCookies_1 = __values(mCookies), mCookies_1_1 = mCookies_1.next(); !mCookies_1_1.done; mCookies_1_1 = mCookies_1.next()) {
                var cookie = mCookies_1_1.value;
                CookieContainer.delete(cookie, domain, path);
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (mCookies_1_1 && !mCookies_1_1.done && (_a = mCookies_1.return)) _a.call(mCookies_1);
            }
            finally { if (e_3) throw e_3.error; }
        }
    };
    return CookiePolicy;
}());
export { CookiePolicy };
